// 引入axios
import axios from 'axios';
import {
  message
} from '@/utils/message'
import errorCode from '@/utils/errorCode'
import {
  baseUrl,
} from './index'
import * as Common from '@/utils/common.js'

//添加默认请求头
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const getToken = localStorage.getItem('token')

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseUrl,
  // 超时
  timeout: 300000,
  // `withCredentials` 表示跨域请求时是否需要使用凭证
  withCredentials: true,
})


// 添加请求拦截器
service.interceptors.request.use(config => {
  //判断是否添加token，true不添加，否则不添加
  const isToken = config.headers.isToken
  if (!isToken) {
    config.headers['Authorization'] = 'Bearer ' + getToken // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  if (config.method === 'get') { // 添加时间戳参数，防止浏览器（IE）对get请求的缓存
    config.params = {
      ...config.params,
      t: new Date().getTime()
    }
  }
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(res => {
  const code = res.data.code || 200;
  const msg = errorCode[code] || res.data.msg || errorCode['default']
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    return res.data
  }

  if (res.code == 200 && res.msg == 'null') {
    message.error('未知错误!')
  } else {
    return res.data
  }


}, error => {
  let errorMessage;
  if (error.message == "Network Error") {
    errorMessage = "后端接口连接异常";
  } else if (error.message.includes("timeout")) {
    errorMessage = "系统接口请求超时";
  } else if (error.message.includes("Request failed with status code")) {
    errorMessage = "系统接口" + error.message.substr(error.message.length - 3) + "异常";
  }
  message.error(errorMessage)
  return Promise.reject(error)
});

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js